import { X, Minus } from "lucide-react";
import { DONT } from "@/data/content";
import { SectionHeading } from "./ui";
import { Reveal } from "./Reveal";

function List({ heading, items, icon: Icon }) {
  return (
    <div className="rounded-sm border border-brand-ivory/12 bg-brand-ivory/[0.03] p-8 lg:p-10">
      <h3 className="font-serif text-2xl text-brand-ivory">{heading}</h3>
      <ul className="mt-6 space-y-3">
        {items.map((it) => (
          <li key={it} className="flex items-start gap-3 text-sm text-brand-ivory/75">
            <Icon className="mt-0.5 h-4 w-4 shrink-0 text-brand-gold" />
            {it}
          </li>
        ))}
      </ul>
    </div>
  );
}

export default function DontDoSection() {
  return (
    <section className="relative bg-brand-graphite py-20 lg:py-32 grain-overlay">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12">
        <SectionHeading dark eyebrow={DONT.eyebrow} title={DONT.title} />
        <div className="mt-14 grid md:grid-cols-2 gap-6 lg:gap-8">
          <Reveal>
            <List heading={DONT.notPromise.heading} items={DONT.notPromise.items} icon={X} />
          </Reveal>
          <Reveal delay={1}>
            <List heading={DONT.notBuild.heading} items={DONT.notBuild.items} icon={Minus} />
          </Reveal>
        </div>
      </div>
    </section>
  );
}
